<template>
    <div class="outline--rightCon">
        <div v-swiper:mySwiper="swiperOptions" class="swiper-container swiper-container1 swiper-container-horizontal">
            <div class="swiper-wrapper">
                <div v-for="(item) in dataList" :key="item.day" class="swiper-slide">
                    <a class="outline--item" v-bind:class="{active: activeDay === item.day}" href="javascript: void(0)" @click="slideTo(item.day)">
                        <p ref="dailyTitle" :style="dailyTitleStyle">{{item.dayTitle}} <span v-if="!active" class="outline--itemRoute">{{item.title}}</span></p>
                        <div v-if="!active" class="outline--travelIcon">
                            <img v-if="item.harborCode&&item.harborCode.indexOf('CRU_')>=0" src="../../assets/outlineBgShip.png">
                            <img v-else src="../../assets/outlineBgCircle.png">
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <!-- 左右按钮 -->
        <div class="swiper-button-prev ti-angle-left" @click="toPrev"></div>
        <div class="swiper-button-next ti-angle-right" @click="toNext"></div>
    </div>
</template>

<script>
    import { directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    export default {
        name: 'TravelNoteDaily',
        directives: {
            swiper: directive
        },
        props: {
            dataList: {
                type: Array,
                default: function () {},
            },
            activeDay: {
                type: Number,
                default: 0,
            },
            active: {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return {
                swiperOptions: {
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled',
                    },
                    slidesPerView : 5,
                    slidesPerGroup : 5
                },
                activeIndex: 0,
                textHeight: 0
            }
        },
        mounted () {
            let maxHeight = 0
            this.$refs.dailyTitle.forEach((ele) => {
                maxHeight = ele.offsetHeight > maxHeight ? ele.offsetHeight: maxHeight
            })
            this.textHeight = maxHeight
        },
        watch: {
            'activeDay' (newVal) {
                let active = Math.floor((newVal - 1) / 3)
                if (this.mySwiper.activeIndex !== active) {
                    if (active > this.activeIndex) this.mySwiper.slideNext()
                    if (active < this.activeIndex) this.mySwiper.slidePrev()
                }
                this.activeIndex = active
            }
        },
        methods: {
            slideTo (day) {
                this.$emit('on-slide-to', day)
            },
            toPrev () {
                this.mySwiper.slidePrev()
            },
            toNext () {
                this.mySwiper.slideNext()
            },
        },
        computed: {
            dailyTitleStyle () {
                if (this.textHeight > 0) {
                    return { height: this.textHeight + "px"}
                } else {
                    return {}
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .outline--rightCon{
        width:86%;
        float: left;
        margin-left:30px;
        a.outline--item {
            display: block;
            position:relative;
            width: 100%;
            padding: 30px 0;
            text-align: center;
            p{
                color:#000;
                vertical-align: middle;
            }
            &.active {
                p{
                    color: #fbba31;
                }
            }
        }
        .outline--travelIcon{
            width:100%;
            img{
                width:100%;
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next {
        position: absolute;
        top: 50%;
        z-index: 10;
        width: 27px;
        height: 44px;
        margin-top: -22px;
        cursor: pointer;
        &::before {
            font-size: 25px;
            color: #5a5a5a;
        }
        &::after {
            font-size: 0;
        }
    }
    .swiper-button-prev {
        left: -4%;
    }
    .swiper-button-next {
        right: -3%;
    }
</style>
